import type React from "react";

export default function BoxHeading({
	icon,
	title,
	className = "",
}: React.PropsWithChildren<{
	icon: React.ReactNode;
	title: string;
	className?: string;
}>) {
	return (
		<div className={`flex flex-row gap-3 text-amber-400 pb-3 ${className}`}>
			<span className="text-2xl">{icon}</span>
			<p className="font-bold">{title}</p>
		</div>
	);
}
